class PaginationHelper {
  static getFirstPost(posts) {
    var _a;
    return (_a = posts === null || posts === void 0 ? void 0 : posts[0]) !== null && _a !== void 0 ? _a : null;
  }
  static getLastPost(posts) {
    var _a;
    return (_a = posts === null || posts === void 0 ? void 0 : posts[posts.length - 1]) !== null && _a !== void 0 ? _a : null;
  }
  static getCurrentIndex(data, postId) {
    return data.findIndex(obj => obj.posts.some(post => post.id === postId));
  }
  static getPrevious(isFirstPost, previousSection, section, pagination) {
    var _a;
    if (isFirstPost && previousSection) {
      return this.getLastPost(previousSection.posts);
    }
    return (_a = section === null || section === void 0 ? void 0 : section.posts.find(post => post.id === (pagination === null || pagination === void 0 ? void 0 : pagination.previous))) !== null && _a !== void 0 ? _a : null;
  }
  static getNext(isLastPost, nextSection, section, pagination) {
    var _a;
    if (isLastPost && nextSection) {
      return this.getFirstPost(nextSection.posts);
    }
    return (_a = section === null || section === void 0 ? void 0 : section.posts.find(post => post.id === (pagination === null || pagination === void 0 ? void 0 : pagination.next))) !== null && _a !== void 0 ? _a : null;
  }
  static getPreviousSection(data, currentIndex) {
    return currentIndex >= 0 ? data[currentIndex - 1] : null;
  }
  static getNextSection(data, currentIndex) {
    return currentIndex < (data === null || data === void 0 ? void 0 : data.length) - 1 ? data[currentIndex + 1] : null;
  }
  static getIsFirstPost(posts, postId) {
    var _a;
    return ((_a = this.getFirstPost(posts)) === null || _a === void 0 ? void 0 : _a.id) === postId;
  }
  static getIsLastPost(posts, postId) {
    var _a;
    return ((_a = this.getLastPost(posts)) === null || _a === void 0 ? void 0 : _a.id) === postId;
  }
  static getPaginationData(data, postId, pagination) {
    var _a, _b;
    const currentIndex = this.getCurrentIndex(data, postId);
    const section = data === null || data === void 0 ? void 0 : data[currentIndex];
    const previousSection = this.getPreviousSection(data, currentIndex);
    const nextSection = this.getNextSection(data, currentIndex);
    const isFirstPost = this.getIsFirstPost((_a = section === null || section === void 0 ? void 0 : section.posts) !== null && _a !== void 0 ? _a : [], postId);
    const isLastPost = this.getIsLastPost((_b = section === null || section === void 0 ? void 0 : section.posts) !== null && _b !== void 0 ? _b : [], postId);
    const previousPost = this.getPrevious(isFirstPost, previousSection, section, pagination);
    const nextPost = this.getNext(isLastPost, nextSection, section, pagination);
    return {
      nextPost,
      previousPost,
      isFirstPost,
      isLastPost,
      nextSection,
      previousSection
    };
  }
}

export { PaginationHelper };
